import React from "react";
import { Card, CardHeader } from "../../UI/DesignStandards";
import BowlerBracketTickets from "../../Brackets/BowlerBracketTickets";
import { isProductShuffledOnSquad } from "../../../utility/brackets/entryTickets";

const EntryBracketsCard = ({
  products,
  slots,
  selectedTickets,
  onTicketChange,
  squadId,
}) => {
  if (!products?.length) return null;
  const named = slots.filter((slot) => String(slot.name || "").trim());
  if (!named.length) return null;

  return (
    <Card className="mb-8">
      <CardHeader
        title="Brackets"
        subtitle="Optional. Add tickets for this squad. You can still buy more at the desk."
      />
      <div className="p-6 space-y-6">
        {named.map((bowler, index) => (
          <div key={`${bowler.name}-${index}`} className="space-y-2">
            {named.length > 1 ? (
              <h3 className="text-sm font-semibold text-brand-charcoal">
                {bowler.name}
              </h3>
            ) : null}
            <BowlerBracketTickets
              products={products}
              counts={selectedTickets[bowler.name] || {}}
              onChange={(productId, nextCount) =>
                onTicketChange(bowler.name, productId, nextCount)
              }
              isShuffled={(product) =>
                isProductShuffledOnSquad(product, squadId)
              }
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default EntryBracketsCard;
